
import {
    defineComponent,
    reactive,
    onMounted,
    ref,
    watch,
    computed,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";
import { config } from "@/Config";

export default defineComponent({
    name: "ProjectWorkflowSmartContractPreview",
    props: {
        contractId: String
    },
    setup(props, { emit }) {
        const router = useRouter();
        // const {
        //     params: { contractId },
        // } = useRoute();
        const state = reactive({
            contractId: props.contractId,
            data: {
                projectTimeline: {} as any,
                smartContractDtail: {} as any,
                companyInfo: {} as any,
                phases: [] as any,
                imageBaseUrl: '' as any,
            },
            ui: {
                error: {
                    hasError: false,
                    errorList: {
                        createPhase: [] as any,
                    },
                },
                isLoading: {
                    getToDoData: false,
                    enableEndDate: true,
                    getSmartContractDetails: false,
                },
                isPostLoading: {
                    createPhase: false,
                    getPhaseDetail: false,
                },
            },
        });

        function getSmartContractDetails() {
            state.ui.isLoading.getSmartContractDetails = true
            ethitransService
                .getSmartContractDetails(state.contractId)
                .then((res: any) => {

                    state.data.smartContractDtail = res.data.data;
                    state.data.projectTimeline = res.data.data.project_date;
                    state.data.smartContractDtail.budget = common.usdPriceFormate(state.data.smartContractDtail.budget);
                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    state.data.smartContractDtail.start_date = common.localDateOnly(state.data.smartContractDtail.start_date);
                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    state.data.smartContractDtail.end_date = common.localDateOnly(state.data.smartContractDtail.end_date);

                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    state.data.smartContractDtail.signature_date = common.localDateOnly(res.data.data.signature_date)
                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    state.data.smartContractDtail.singed_customers.forEach((customer: any) => {
                        // eslint-disable-next-line @typescript-eslint/camelcase  
                        customer.signaute_date = common.localDateOnly(customer.signaute_date)
                    })
                    state.data.phases = res.data.data.phases;
                    state.data.phases.forEach((phase: any) => {
                        phase.budget = common.usdPriceFormate(phase.budget);

                        // eslint-disable-next-line @typescript-eslint/camelcase  
                        phase.start_date = common.localDateOnly(phase.start_date);
                        // eslint-disable-next-line @typescript-eslint/camelcase  
                        phase.end_date = common.localDateOnly(phase.end_date);
                        phase.child_phases.forEach((child: any) => {
                            console.log('The Child phase data is>>>', child);
                            child.budget = common.usdPriceFormate(child.budget);
                            child.startDate = child.start_date ? common.localDateOnly(child.start_date) : '-';
                            child.endDate = child.end_date ? common.localDateOnly(child.end_date) : '-';
                        });

                    });
                    state.data.companyInfo = res.data.data.company;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getSmartContractDetails = false;
                });
        }

        function downoadPdf(url: any) {

            window.open(url, '_blank');
        }

        function goToSmartContract() {
            // router.push({
            //     name: "smart-contract-list",
            //     params: { projectId: state.data.smartContractDtail.project_id },
            // });
            emit('back-to-smart-contract-list');
        }
        function handleImageInNewTab(url: any) {
            window.open(config.liveImageBaseUrl + url, '_blank');
        }


        function usdPriceFormate(data: any) {
            if (data != null) {
                return data.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                });
            }

        }
        // function calculateTaskDays(timeline: any) {
        //     console.log('The timeline is>>> ', timeline);

        //     // if (!timeline || timeline.value == null || timeline.type == null) return '0 days';

        //     let days = 0;
        //     let isTBD = false;

        //     const type = String(timeline.type);
        //     const value = Number(timeline.value);

        //     console.log('The timeline.value is', timeline.value);
        //     console.log('Parsed value is', value);
        //     console.log('The timeline.type is', type);

        //     switch (type) {
        //         case '1': // days
        //             days = value;
        //             break;
        //         case '2': // weeks
        //             days = value * 7;
        //             break;
        //         case '3': // months
        //             days = value * 30;
        //             break;
        //         case '4': // TBD
        //             isTBD = true;
        //             days = value || 0;
        //             break;
        //     }

        //     // Only subtract weekends if checkbox is selected
        //     if (timeline.excludeWeekends === 1 && days > 0) {
        //         const weeks = Math.floor(days / 7);
        //         const extraDays = days % 7;
        //         const excludedWeekends = weeks * 2;
        //         const additionalExcluded = extraDays >= 6 ? 2 : extraDays >= 1 ? 1 : 0;
        //         days -= (excludedWeekends + additionalExcluded);
        //         console.log('Days after excluding weekends:', days);
        //     } else {
        //         console.log('Weekends included, no change in day count.');
        //     }

        //     const result = isTBD && days === 0 ? 'TBD' : isTBD ? `${days} + TBD days` : `${days} days`;
        //     console.log('Final result:', result);
        //     return result;
        // }



        // function getPhaseTotalDays(phase: any) {
        //     let totalDays = 0;
        //     let tbdCount = 0;
        //     console.log('The phase data is:::', phase);

        //     const tasks = phase.child_phases || phase.groupTasks || [];
        //     console.log('The tasks are:::', tasks);

        //     tasks.forEach((task: any) => {
        //         console.log('Each task is :::', task);

        //         const dayString = calculateTaskDays(task.time_line);

        //         if (dayString.includes('TBD')) {
        //             tbdCount++;
        //         }

        //         const match = dayString.match(/^(\d+)/);
        //         if (match && match[1]) {
        //             totalDays += Number(match[1]);
        //         }
        //     });

        //     // Final output based on TBD and totalDays
        //     let result = '';
        //     if (tbdCount > 0 && totalDays === 0) {
        //         result = 'TBD';
        //     } else if (tbdCount > 0 && totalDays > 0) {
        //         result = `${totalDays} + TBD days`;
        //     } else {
        //         result = `${totalDays} days`;
        //     }

        //     console.log('Final result:', result);
        //     return result;
        // }


        // function getProjectTotalDays(phases: any[]) {
        //     if (!Array.isArray(phases)) return '0 days';

        //     let totalDays = 0;
        //     let tbdCount = 0;

        //     phases.forEach(phase => {
        //         const phaseTotal = getPhaseTotalDays(phase);

        //         if (phaseTotal.includes('TBD')) {
        //             const tbdMatch = phaseTotal.match(/(\d+)\s\+\sTBD/);
        //             if (tbdMatch) {
        //                 totalDays += Number(tbdMatch[1]);
        //                 tbdCount += 1;
        //             } else if (phaseTotal === 'TBD') {
        //                 tbdCount += 1;
        //             }
        //         } else {
        //             const match = phaseTotal.match(/^(\d+)/);
        //             if (match && match[1]) {
        //                 totalDays += Number(match[1]);
        //             }
        //         }
        //     });

        //     // Final output
        //     let result = '';
        //     if (tbdCount > 0 && totalDays === 0) {
        //         result = 'TBD';
        //     } else if (tbdCount > 0 && totalDays > 0) {
        //         result = `${totalDays} + TBD days`;
        //     } else {
        //         result = `${totalDays} days`;
        //     }

        //     console.log('Project total days:', result);
        //     return result;
        // }
        const formatDate = (date: string | null) => {
            return date ? common.localDateOnly(date) : '';
        };

        function calculateTaskDays(timeline: any) {
            console.log('The timeline is>>> ', timeline);

            if (!timeline || timeline.type == null || (timeline.type !== 4 && timeline.value == null)) {
                return '0 days';
            }

            let days = 0;
            let isTBD = false;

            const type = String(timeline.type);
            const value = Number(timeline.value);

            switch (type) {
                case '1': // days
                    days = value;
                    break;
                case '2': // weeks
                    days = value * 7;
                    break;
                case '3': // months
                    days = value * 30;
                    break;
                case '4': // TBD
                    isTBD = true;
                    break;
            }

            // Only subtract weekends if checkbox is selected
            if (timeline.excludeWeekends === 1 && days > 0) {
                const fullWeeks = Math.floor(days / 7);
                const excludedWeekends = fullWeeks * 2;
                console.log('Excluding weekends:', excludedWeekends, 'from', days);
                days -= excludedWeekends;
                console.log('Days after excluding weekends:', days);
            }

            const result = (days === 0 && isTBD) ? 'TBD' : isTBD ? `${days} + TBD days` : `${days} days`;
            console.log('Final result:', result);
            return result;
        }

        function getPhaseTotalDays(phase: any) {
            let totalDays = 0;
            let hasTBD = false;
            const tasks = phase.child_phases || phase.groupTasks || [];
            tasks.forEach((task: any) => {
                const timeline = task.time_line;

                // if (!timeline || timeline.value == null || timeline.type == null) return;

                let days = 0;

                switch (timeline.type.toString()) {
                    case '1': // Days
                        days = Number(timeline.value);
                        break;
                    case '2': // Weeks
                        days = Number(timeline.value) * 7;
                        break;
                    case '3': // Months
                        days = Number(timeline.value) * 30;
                        break;
                    case '4': // TBD
                        hasTBD = true;
                        break;
                    default:
                        break;
                }

                if (timeline.excludeWeekends === 1 && days > 0) {
                    const fullWeeks = Math.floor(days / 7);
                    const excludedWeekends = fullWeeks * 2;
                    days -= excludedWeekends;
                }

                totalDays += days;
            });

            return hasTBD
                ? totalDays === 0 ? 'TBD' : `${totalDays} + TBD days`
                : `${totalDays} days`;
        }

        function calculateProjectTotalDays(phases: any[]): string {
            let projectTotalDays = 0;
            let hasTBD = false;

            console.log('Calculating project total days...');

            phases.forEach((phase: any) => {
                const phaseTotalDays = getPhaseTotalDays(phase);

                console.log('Phase Total Days:', phaseTotalDays);

                if (phaseTotalDays.includes('TBD')) {
                    hasTBD = true;
                }

                const numericDays = parseInt(phaseTotalDays);
                if (!isNaN(numericDays)) {
                    projectTotalDays += numericDays;
                }
            });

            // Return formatted result
            if (projectTotalDays === 0 && hasTBD) {
                return 'TBD';
            } else if (hasTBD) {
                return `${projectTotalDays} + TBD days`;
            } else {
                return `${projectTotalDays} days`;
            }
        }

        onMounted(() => {
            state.data.imageBaseUrl = config.imageBaseUrl;
            getSmartContractDetails();
        });

        return {
            state,
            calculateTaskDays,
            getPhaseTotalDays,
            calculateProjectTotalDays,
            handleImageInNewTab,
            getSmartContractDetails,
            downoadPdf,
            goToSmartContract,
            usdPriceFormate,
            formatDate
        };
    },
});
